import React, { useState, useEffect } from "react";
import { Button, Box } from "rebass";
import { getLocalizedString } from "../../utils";
import { ToastMessage } from "./ToastMessage";

const SelectDoor = ({ closeDoors, doors = [], save, selected, style }) => {
  const [selectedDoors, setSelectedDoors] = useState([
    ...doors.filter((d) => d.code == "M"),
    ...doors.filter((d) => d.code != "M"),
  ]);

  const [noDoorMessage, setNoDoor] = useState(null);
  const [allSelected, setAllSelected] = useState(false);

  function selectAll() {
    const changedDoors = selectedDoors.map((door) => {
      return {
        ...door,
        checked: allSelected ? false : true,
      };
    });
    setSelectedDoors(changedDoors);
    setAllSelected(!allSelected);
  }

  useEffect(() => {
    if (doors && selected && selected.length > 0) {
      const changedDoors = selectedDoors.map((door) => {
        if (selected.filter((d) => d.id === door.id).length > 0) {
          return {
            ...door,
            checked: !door.checked,
          };
        } else {
          return { ...door };
        }
      });
      setSelectedDoors(changedDoors);
    }
  }, [doors, selected]);

  function changeSelected(doorId) {
    const changedDoors = selectedDoors.map((door) => {
      if (door.id === doorId) {
        return {
          ...door,
          checked: !door.checked,
        };
      } else {
        return { ...door };
      }
    });
    setSelectedDoors(changedDoors);
  }
  return (
    <Box style={{ backgroundColor: "rgba(0,0,0,.85" }} className="modal">
      <ToastMessage
        message={noDoorMessage}
        confirmFunction={() => {
          setNoDoor(null);
        }}
        style={{ width: 600 }}
      />
      <div className="modal-content" style={style}>
        <div className="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <ul className="divide-y divide-gray-300 divide-dashed">
            <li key="selectall" className="py-4 flex">
              <input
                type="checkbox"
                checked={allSelected}
                onChange={() => selectAll()}
              />
              <div className="ml-3">
                <p className="text-sm font-small text-gray-500 text-small">
                  {getLocalizedString("Select door information").toUpperCase()}
                </p>
              </div>
            </li>
            {selectedDoors.map((d) => (
              <li key={d.id} className="py-4 flex">
                <input
                  type="checkbox"
                  checked={
                    d.checked /*|| selected.filter(s => s.code == d.code).length > 0 */
                  }
                  onChange={() => changeSelected(d.id)}
                />
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-800 font-semibold text-base">
                    {d.code} - {d.name}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="relative right-0 top-0 pt-12 hidden md:block md:w-full">
          <span className="px-4 py-3 md:flex md:flex-row-reverse md:px-6">
            <Button
              disabled={selectedDoors.filter((s) => s.checked).length > 5}
              onClick={() => {
                if (selectedDoors.filter((s) => s.checked).length == 0) {
                  setNoDoor(getLocalizedString("No Doors"));
                } else {
                  save(selectedDoors.filter((s) => s.checked));
                  closeDoors();
                }
              }}
              sx={{
                "&:hover": {
                  backgroundColor: "#909090",
                  border: "1px solid #909090",
                  color: "white",
                },
                border: "1px solid #333",
                backgroundColor: "#333",
                width: "150px",
                marginLeft: "10px",
              }}
            >
              {selectedDoors.filter((s) => s.checked).length > 5 &&
                getLocalizedString("Max 5 Doors")}

              {selectedDoors.filter((s) => s.checked).length <= 5 &&
                getLocalizedString("Salva")}
            </Button>
            <Button
              onClick={() => {
                closeDoors();
              }}
              sx={{
                "&:hover": {
                  backgroundColor: "#909090",
                  border: "1px solid #909090",
                  color: "white",
                },
                border: "1px solid #333",
                backgroundColor: "white",
                width: "150px",
                color: "black",
                marginRight: "10px",
              }}
            >
              {getLocalizedString("Annulla")}
            </Button>
          </span>
        </div>
        <div className="relative top-0 pt-10 md:hidden block md:w-full">
          <Button
            disabled={selectedDoors.filter((s) => s.checked).length > 5}
            onClick={() => {
              if (selectedDoors.filter((s) => s.checked).length == 0) {
                setNoDoor(getLocalizedString("No Doors"));
              } else {
                save(selectedDoors.filter((s) => s.checked));
                closeDoors();
              }
            }}
            sx={{
              "&:hover": {
                backgroundColor: "#909090",
                border: "1px solid #909090",
                color: "white",
              },
              border: "1px solid #333",
              backgroundColor: "#333",
              width: "100%",
              marginRight: "10px",
            }}
          >
            {getLocalizedString("Salva")}
          </Button>
        </div>
        <div className="relative top-0 pt-1 md:hidden block w-full">
          <Button
            disabled={selectedDoors.filter((s) => s.checked).length > 5}
            onClick={() => {
              closeDoors();
            }}
            sx={{
              "&:hover": {
                backgroundColor: "#909090",
                border: "1px solid #909090",
                color: "white",
              },
              border: "1px solid #333",
              backgroundColor: "white",
              width: "100%",
              color: "black",
              marginRight: "10px",
            }}
          >
            {getLocalizedString("Annulla")}
          </Button>
        </div>
      </div>
    </Box>
  );
};

export { SelectDoor };
